import React, { Component } from 'react';
import { connect } from 'react-redux';
import ActivityFeed from "../ActivityFeed/ActivityFeed";
import { fetchFeed, postFeed, getToken } from "../redux/actions";
import {rankSelector, feedSelector, userSelector, chapterSelector, usersOnlineSelector} from '../redux/selectors';


class ActivityFeedContainer extends Component {
    render() {
        return (
            <div className="panel-adt">
                <ActivityFeed
                    open={this.props.rightPanelOpen}
                    feed={this.props.feed}
                    users={this.props.users}
                    ranks={this.props.ranks}
                    chapters={this.props.chapters}
                    onSubmit={this.props.onSubmit}
                    isAuthenticated={this.props.isAuthenticated}
                    appendFeed={this.props.appendFeed}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.auth.loggedIn,
        feed: feedSelector(state),
        ranks: rankSelector(state),
        users: userSelector(state),
        chapters: chapterSelector(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        appendFeed: (limit, offset) => dispatch(fetchFeed(limit, offset)),
        login: ( username, password) => dispatch(getToken(username, password)),
        onSubmit: (values) => dispatch(postFeed(values.body)),
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(ActivityFeedContainer);


// WEBPACK FOOTER //
// ./src/ActivityFeed/ActivityFeedContainer.js